import { FeatureSet } from '@Config/Experiments';
import { ExperimentSet } from '@Framework/experiments';

export enum CoreShopEnvironment {
  Prod = 'prod',
  Qs = 'qs',
  Dev = 'dev'
}

export enum RouterEngine {
  history = 'browser',
  memory = 'memory'
}

export type AppConfig = {
  features: FeatureSet;
  experiments: ExperimentSet;
  tenant: string;
  coreShopEnvironment: string;
  language: string;
  referrerUrl?: string;
  branchPreviewUrl?: string;
  branchPreviewName?: string;
  triggerTrackingEvent?: (eventName: string, eventTags?: string[]) => void;
  triggerDatalayerEvent?: (eventName: string) => void;
  routerEngine?: RouterEngine;
};
